class Accordion {

    constructor(selector) {
        this.selector   = selector;
        this.accordions = document.querySelectorAll(this.selector);
    }

    disableFocus() {
        this.accordions.forEach((element) => {
            const content    = element.lastElementChild;
            content.setAttribute('inert', '');
        });
    }
    
    initClickHandler() {
        document.addEventListener("click", (e) => {

            const accordion  = e.target?.closest(`${this.selector}`);
            const accordions = document.querySelectorAll(this.selector);
            
            if (accordion) {

                const isClosed   = !accordion.classList.contains('js-accordion--opened');
                const button     = accordion.querySelector('[aria-expanded]');
                const content    = accordion.lastElementChild;
    
                accordions.forEach((element) => {
                    const button  = element.querySelector('[aria-expanded]');
                    const content = element.lastElementChild;

                    element.classList.remove('js-accordion--opened');
                    button.setAttribute('aria-expanded', false);
                    content.setAttribute('inert', '');
                });
    
                if (isClosed) {
                    accordion.classList.add('js-accordion--opened');
                    button.setAttribute('aria-expanded', true);
                    content.removeAttribute('inert');
                }
            }

        }, false);
    }

    init() {
        this.disableFocus();
        this.initClickHandler();
    }
}

export const initAccordion = (selector) => {
    const newAcc = new Accordion(selector);
    newAcc.init();
}
